export class PlantHelper{
  public static getPlantCode(location: any): string {
		return location && location.pathname && location.pathname.split('/').length > 2 && location.pathname.split('/')[2];;
  }
}
